import { matchRoutes, useLocation } from "react-router-dom";

const routeList = [
  "/",
  "/policy",
  "/reviews",
  "/services",
  "/services/talkitout",
  "/services/career-consult",
  "/services/cv-ready",
  "/services/linkedin-boost",
  "/services/vacancies",
  "/services/search-support",
  "/services/probation-support",
  "/services/it-hiring",
  "/services/it-training",
  "/services/c-level",
  "/services/career-audit",
  "/blog",
  "/blog/:id",
  "/company",
  "/consent",
  "/notification-consent",
];

export const useIsNotFoundPage = () => {
  const location = useLocation();

  const matched = matchRoutes(
    routeList.map((path) => ({ path })),
    location
  );

  return !matched;
};
